export default __webpack_public_path__ + "static/media/e-commerce.4e713141.svg";